<template>
    <div class="image-bg" :style="`background-image:url(${bgImages});text-align:${align};color:${color}`">
        <div class="title">
            {{ title }}
        </div>
        <div class="min-title">
            {{ minTitle }}
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
    props: {
        title: {
            type: String
        },
        minTitle: {
            type: String
        },
        bgImages: {
            type: String
        },
        align: {
            type: String,
            default: 'center'
        },
        color: {
            type: String,
            default: '#fff'
        }
    }
}
</script>
<style scoped>
.image-bg {
    width: 100%;
    height: 180px;
    background-size: cover;
    color: #fff;
    box-sizing: border-box;
    padding: 30px;
}
.title {
    /* text-align: center; */
    font-size: 26px;
    font-family: ITC Avant Garde Gothic Std;
    font-weight: bold;
    /* color: #FFFFFF; */
    padding-top: 20px;
}
.min-title {
    /* text-align: center; */
    font-size: 18px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    /* color: #FFFFFF; */
}
</style>